import React from "react";
import {Form} from "antd";
import Seperator from "./Seperator";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

/*
사업자   : SKT, KT, LGU+ customer_name_abbr
높이     : 15~30m, 30m 이상 terrain_altitude
설치형태 : 강관주, 쌍통신주, IP주(소형 강관주), 통신주(CP주), 철탑(지면) form_name
 */
const OPTIONS_CUSTOMER = [
  { customer_name_abbr : "SK", label: "SKT" },
  { customer_name_abbr : "KT", label: "KT" },
  { customer_name_abbr : "LG", label: "LGU+" },
];

const OPTIONS_ALTITUDE = [
  { terrain_altitude : "A", label: "15~30m" },
  { terrain_altitude : "B", label: "30m 이상" },
];

const OPTIONS_FORM = [
  { form_code: "2", label: "강관주" },
  { form_code: "8", label: "쌍통신주" },
  { form_code: "10", label: "IP주(소형 강관주)" },
  { form_code: "3", label: "통신주(CP주)" },
  { form_code: "1", label: "철탑(지면)" },
];


function WidgetCellularCommon() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="사업자"
        fieldName={"customer_name_abbr_list"}
        options={OPTIONS_CUSTOMER.map(({ customer_name_abbr, label }) => ({
          value: customer_name_abbr,
          label,
        }))}
        colSpan={8} />

      <Seperator />

      <CheckboxGroupWithCheckAll
        title="높이"
        fieldName={"terrain_altitude_list"}
        options={OPTIONS_ALTITUDE.map(({ terrain_altitude, label }) => ({
          value: terrain_altitude,
          label,
        }))}
        colSpan={8} />

      <Seperator />

      <CheckboxGroupWithCheckAll
        title="설치형태"
        fieldName={"form_code_list"}
        options={OPTIONS_FORM.map(({ form_code, label }) => ({
          value: form_code,
          label,
        }))}
        colSpan={12} />
    </Form.Item>
  );
}


export default WidgetCellularCommon;
